









































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class VualtoNav extends Vue {
    private drawer: boolean = true;
    private items: Array<{ title: string, route: string, icon: string }> = [
        { title: 'Home', route: 'home', icon: 'home' },
        { title: 'No DRM', route: 'nodrm', icon: 'check_circle' },
        { title: 'DRM', route: 'drm', icon: 'copyright' },
        { title: 'Custom stream', route: 'custom', icon: 'extension' },
        { title: 'YouTube', route: 'youtube', icon: 'video_library' },
        { title: 'Multiple player', route: 'multi', icon: 'view_module' },
        { title: 'About', route: 'about', icon: 'info' },
        { title: 'Default settings', route: 'settings', icon: 'settings' },
    ];
    private mini: boolean = true;
    private baseUrl: any = process.env.BASE_URL;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/layout/VualtoNav.vue